module.exports = __webpack_public_path__ + "static/media/home.1724f967.svg";